import React from "react";
import ByzMuiDataGrid from "src/components/core-components/mui/data-grid";
import {
  GridColDef,

} from "@mui/x-data-grid-premium";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import { getColumns, rows as morningRows } from "./data";
import { useTranslate } from "src/locales";
import ByzDataGridToolbar from "src/components/core-components/mui/data-grid/toolbar";

//CKAPISIZ;452424;05052004
interface PageMorningProps {
  startDate: Date | null;
  endDate: Date | null;
  selectedIds: number[];
  onToggleRow: (row: any) => void;
}

const PageFavorites: React.FC<PageMorningProps> = ({
  selectedIds,
  onToggleRow,
}) => {
  const { t } = useTranslate();
  const afternoonColumns = getColumns(t);

  const topColumns: GridColDef[] = afternoonColumns.map((col) =>
    col.field === "select"
      ? {
          ...col,
          renderCell: (params) => {
            const checked = selectedIds.includes(params.row.id);
            return (
              <>
                <ByzMuiCheckBox
                  checked={checked}
                  onChange={() => onToggleRow(params.row)}
                />
              </>
            );
          },
        }
      : col
  );
  return (
    <ByzMuiDataGrid
      sx={{ padding: "20px" }}
      customToolbar={ByzDataGridToolbar}
      rows={morningRows}
      columns={topColumns}
      pageSize={5}
      disableProcessMenu
    />
  );
};

export default PageFavorites;
